<template>
  <el-dialog
    class="dialog-smart-subscribe-error"
    :visible="isShowDialogSmartSubscribeError"
    width="440px"
    :show-close="false"
  >
    <span slot="title" class="el-dialog__title"> <i class="iconfont icon-close-sm" />订阅失败 </span>

    <div class="content">
      <div class="row">
        <div class="value">{{ errorMessage }}</div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="viewSetting">去设置</el-button>
      <el-button @click="handleConfirm">我知道了</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL } from "@/utils/constants/constants.menu";

export default {
  name: "DialogSmartSubscribeError",
  computed: {
    isShowDialogSmartSubscribeError() {
      return this.$store.getters["industryZone/isShowDialogSmartSubscribeError"];
    },
    errorMessage() {
      return this.$store.getters["industryZone/errorMessage"];
    },
  },
  methods: {
    viewSetting() {
      window.open(SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL);
      this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeError", false);
    },
    handleConfirm() {
      this.$store.commit("industryZone/updateIsShowDialogSmartSubscribeError", false);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/config";

.dialog-smart-subscribe-error {
  .el-dialog__body {
    padding: 0 20px 20px 20px;
    color: $theme-font-color;
  }

  .el-dialog__title {
    display: flex;
    align-items: center;

    i {
      color: #fff;
      width: 24px;
      height: 24px;
      font-size: 18px;
      background: $theme-color;
      border-radius: 50%;
      text-align: center;
      margin-right: 10px;
      margin-left: 5px;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../../../assets/config";

.content {
  padding: 0 24px;

  .row {
    margin-top: 20px;
    display: flex;

    .label {
      flex-shrink: 0;
      color: #595959;
    }

    .value {
      margin-left: 15px;

      //单行
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }

    a {
      color: $theme-color;
    }
  }
}
</style>
